// extracted by mini-css-extract-plugin
export default {"statusBar_icon":"StatusBarActionIcon_statusBar_icon__kc5xk","statusBar_icon___active":"StatusBarActionIcon_statusBar_icon___active__3gdal"};